import { render } from "./AddFlight.vue?vue&type=template&id=372b0259&scoped=true"
import script from "./AddFlight.vue?vue&type=script&lang=js"
export * from "./AddFlight.vue?vue&type=script&lang=js"

import "./AddFlight.vue?vue&type=style&index=0&id=372b0259&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372b0259"]])

export default __exports__